'use strict';

angular.module('nfseApp')
    .controller('NotaFiscalDetailController',
        function ($scope, $rootScope, $modal, $stateParams, entity, NotaFiscal, NotaNacional, Notificacao) {
            $scope.notaFiscal = entity;
            $scope.retornosDfeAdn = [];
            $scope.podeIntegrarNotaNacional = false;
            $scope.podeEnviarEventoCancelamento = false;

            NotaFiscal.getParcelasDaNota({id: $stateParams.id}, function (res) {
                $scope.parcelas = res;
            });

            $scope.buscarRetornosDfeAdn = function () {
                NotaNacional.buscarRetornosDfeAdn({notaFiscalId: $scope.notaFiscal.id}, function (data) {
                    $scope.retornosDfeAdn = data;
                    $scope.podeIntegrarNotaNacional = !$scope.existeIntegracaoNotaNacionalComSucesso();
                    $scope.podeEnviarEventoCancelamento = $scope.notaCancelada() &&
                        $scope.existeIntegracaoNotaNacionalComSucesso() &&
                        !$scope.existeEventoCancelamentoComSucesso();
                });
            };

            $scope.buscarRetornosDfeAdn();

            $scope.load = function (id) {
                NotaFiscal.get({id: id}, function (result) {
                    $scope.notaFiscal = result;

                });
            };

            $rootScope.$on('nfseApp:notaFiscalUpdate', function (event, result) {
                $scope.notaFiscal = result;
            });

            $scope.existeRetornoComSucesso = function (tipoDfe) {
                if ($scope.retornosDfeAdn && $scope.retornosDfeAdn.length > 0) {
                    for (var i = 0; i < $scope.retornosDfeAdn.length; i++) {
                        var retorno = $scope.retornosDfeAdn[i];
                        if (retorno.statusProcessamento === 'PROCESSADO_COM_SUCESSO' && retorno.tipoDfe === tipoDfe) {
                            return true;
                        }
                    }
                }
                return false;
            };

            $scope.existeIntegracaoNotaNacionalComSucesso = function () {
                return $scope.existeRetornoComSucesso('NFSE');
            };

            $scope.existeEventoCancelamentoComSucesso = function () {
                return $scope.existeRetornoComSucesso('EVENTO_CANCELAMENTO') ||
                    $scope.existeRetornoComSucesso('EVENTO_CANCELAMENTO_SUBSTITUICAO');
            };

            $scope.notaCancelada = function () {
                return $scope.notaFiscal && $scope.notaFiscal.declaracaoPrestacaoServico &&
                    $scope.notaFiscal.declaracaoPrestacaoServico.situacao === 'CANCELADA';
            };

            $scope.integrarNotaNacional = function () {
                NotaNacional.integrar({notaFiscalId: $scope.notaFiscal.id}, function () {
                    Notificacao.info('Informação', 'Nfs-e enviada para integração com a Nfs-e Nacional.');
                });
            };

            $scope.enviarEventoCancelamento = function () {
                // Desabilita antes da chamada: dois cliques seguidos publicariam duas mensagens na fila.
                $scope.podeEnviarEventoCancelamento = false;
                NotaNacional.integrarEventoCancelamento({notaFiscalId: $scope.notaFiscal.id}, function () {
                    Notificacao.info('Informação', 'Cancelamento enviado para a Nfs-e Nacional. ' +
                        'O retorno aparece no quadro de integração assim que for processado.');
                }, function () {
                    $scope.podeEnviarEventoCancelamento = true;
                });
            };

            $scope.exibirMensagensNotaNacional = function (retorno) {
                NotaNacional.buscarMensagensDfeAd({retornoId: retorno.id}, function (data) {
                    $modal.open({
                        templateUrl: 'app/entities/notaNacional/mensagem-dfe-adn.html',
                        controller: 'MensagemDfeAdnController',
                        size: 'lg',
                        resolve: {
                            mensagens: function () {
                                return data;
                            }
                        }
                    });
                });
            };
        });
